import { AccountsTable } from './BankAccountsTable/AccountsTable'
import { TBankAccountProps } from './types'
import { Banner } from 'components/Banner/Banner'

export const BankAccount = ({
  businessDetails,
  getBusinessDetails
}: TBankAccountProps) => {
  // ECOG01-11876 -- [Moov] "pending_creation_bank_accounts_counter" isn’t changed after page refreshing -- hide this banner for now
  const showPendingCreationBankAccountsCounter = false

  const counterOfCreatingAccounts =
    businessDetails.pending_creation_bank_accounts_counter || 0

  return (
    <div className="column gap-24">
      {showPendingCreationBankAccountsCounter &&
        counterOfCreatingAccounts > 0 && (
          <Banner.Info
            text={`Creating ${counterOfCreatingAccounts} bank account${
              counterOfCreatingAccounts > 1 ? 's' : ''
            }. Please wait a few minutes, then refresh the page to see the update`}
          />
        )}
      <AccountsTable
        businessDetails={businessDetails}
        getBusinessDetails={getBusinessDetails}
      />
    </div>
  )
}
